import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './session-expired-modal.css';

export const SessionExpiredModal = () => {
  const { sessionExpired, dismissExpired } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!sessionExpired) return null;

  const handleSignIn = () => {
    dismissExpired();
    const returnTo = encodeURIComponent(location.pathname + location.search);
    navigate(`/login?returnTo=${returnTo}`);
  };

  return (
    <div className="sem-overlay">
      <div className="sem-modal" role="dialog" aria-modal="true" aria-labelledby="sem-title">
        <div className="sem-icon"></div>
        <h2 className="sem-title" id="sem-title">Session Expired</h2>
        <p className="sem-body">
          Your session has timed out for security. Sign back in to continue — your work is still here.
        </p>
        <button className="sem-btn" onClick={handleSignIn}>
          Sign In Again
        </button>
      </div>
    </div>
  );
};
